import { makeAutoObservable } from 'mobx'

import { SVEA_KEY } from 'constants/options.constants'

import { ShopRootStore } from 'shop/stores/shopRoot.store'
import {
  CURRENCY_COUNTRY_MAP,
  SVEA_COUNTRIES,
  SVEA_MIN_AMOUNT,
  SVEA_MAX_AMOUNT,
} from 'constants/paymentSettingShared.constants'
import { PAYMENT_PLANS } from 'constants/pricingPlans.constants'

export class ShopSveaPaymentMethodStore {
  storeName = 'shopSveaPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  isAppActive() {
    const isPowerSeller = !!this.root.sellerStore.item?.powerSeller
    const isFeatureFlagOn = !!this.root.experimentsStore.getFeatureGate('svea_method')?.value
    const isOptionKeyActive = this.root.sellerStore.isAppActive(SVEA_KEY)

    return isPowerSeller && isFeatureFlagOn && isOptionKeyActive
  }

  isAvailable = (activeCountry: string, currency: string): boolean => {
    const country = (activeCountry || 'DE').toUpperCase()
    return (
      this.isAppActive() &&
      SVEA_COUNTRIES.includes(country) &&
      !!CURRENCY_COUNTRY_MAP[currency.toUpperCase()]?.includes(country)
    )
  }

  isAvailableForPricingPlan = ({ withTestPeriod, withCustomStart, pricingPlanForm }) =>
    !withTestPeriod && !withCustomStart && pricingPlanForm === PAYMENT_PLANS.oneTime

  isAvailableForAmount = (amount: number): boolean =>
    Number(amount) >= SVEA_MIN_AMOUNT && Number(amount) <= SVEA_MAX_AMOUNT
}
